/**
 * @generated SignedSource<<d4cd824239a1494a17d7a10384ddd401>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TaxStatus = "EXEMPT" | "REGULAR" | "REVERSE_CHARGE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CustomerAccountView_customerAccount$data = {
  readonly businessAddress: {
    readonly addressLine1: string | null | undefined;
    readonly addressLine2: string | null | undefined;
    readonly businessName: string;
    readonly city: string;
    readonly country: string;
    readonly postalCode: string;
  } | null | undefined;
  readonly customerAccountIdentifier: string;
  readonly customerName: string;
  readonly customerNumber: string;
  readonly customerSince: any | null | undefined;
  readonly id: string;
  readonly preferredLanguage: string;
  readonly taxStatus: TaxStatus | null | undefined;
  readonly vatId: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteCustomerDialog_customerAccount">;
  readonly " $fragmentType": "CustomerAccountView_customerAccount";
};
export type CustomerAccountView_customerAccount$key = {
  readonly " $data"?: CustomerAccountView_customerAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"CustomerAccountView_customerAccount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CustomerAccountView_customerAccount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerAccountIdentifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerSince",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vatId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preferredLanguage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BusinessAddress",
      "kind": "LinkedField",
      "name": "businessAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "businessName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "addressLine1",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "addressLine2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postalCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "country",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteCustomerDialog_customerAccount"
    }
  ],
  "type": "CustomerAccount",
  "abstractKey": null
};

(node as any).hash = "5e0fefbca113e3ec9ad4fd282a010a32";

export default node;
